import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const CommuneOverview = ({ commune }) => {
  if (!commune) return null;

  const highlights = [
    {
      icon: 'Users',
      label: 'Population',
      value: commune?.population,
      color: 'text-blue-600'
    },
    {
      icon: 'MapPin',
      label: 'Superficie',
      value: commune?.area,
      color: 'text-green-600'
    },
    {
      icon: 'TrendingUp',
      label: 'Prix Moyen',
      value: commune?.averagePrice,
      color: 'text-brand-gold'
    },
    {
      icon: 'Star',
      label: 'Note Qualité',
      value: commune?.qualityRating + '/5',
      color: 'text-orange-500'
    }
  ];

  return (
    <div className="bg-white">
      <div className="max-w-7xl mx-auto px-4 lg:px-6 py-12">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Content */}
          <div>
            <div className="flex items-center space-x-2 mb-4">
              <Icon name="Info" size={20} className="text-brand-gold" />
              <span className="text-sm font-medium text-brand-gold uppercase tracking-wide">
                Aperçu de la Commune
              </span>
            </div>
            
            <h2 className="text-3xl lg:text-4xl font-heading font-bold text-text-primary mb-6">
              Découvrez {commune?.name}
            </h2>
            
            <p className="text-lg text-text-secondary mb-8 leading-relaxed">
              {commune?.detailedDescription}
            </p>
            
            {/* Highlights Grid */}
            <div className="grid grid-cols-2 gap-6 mb-8">
              {highlights?.map((highlight, index) => (
                <div key={index} className="flex items-center space-x-3">
                  <div className={`p-2 rounded-lg bg-surface ${highlight?.color}`}>
                    <Icon name={highlight?.icon} size={20} />
                  </div>
                  <div>
                    <p className="text-sm text-text-secondary">{highlight?.label}</p>
                    <p className="font-semibold text-text-primary">{highlight?.value}</p>
                  </div>
                </div>
              ))}
            </div>
            
            {/* Key Features */}
            <div>
              <h3 className="font-heading font-semibold text-text-primary mb-4">
                Points Forts
              </h3>
              <div className="space-y-2">
                {commune?.keyFeatures?.map((feature, index) => (
                  <div key={index} className="flex items-center space-x-2">
                    <Icon name="Check" size={16} className="text-green-600" />
                    <span className="text-text-secondary">{feature}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
          
          {/* Image Gallery */}
          <div className="space-y-4">
            <div className="relative h-64 rounded-xl overflow-hidden shadow-warm">
              <Image
                src={commune?.galleryImages?.[0]}
                alt={`Vue principale de ${commune?.name}`}
                className="w-full h-full object-cover"
              />
              <div className="absolute top-4 right-4">
                <button className="bg-white/90 backdrop-blur-sm p-2 rounded-lg hover:bg-white transition-colors duration-300">
                  <Icon name="Play" size={20} className="text-text-primary" />
                </button>
              </div>
            </div>
            
            <div className="grid grid-cols-2 gap-4">
              {commune?.galleryImages?.slice(1, 3)?.map((image, index) => (
                <div key={index} className="relative h-32 rounded-lg overflow-hidden">
                  <Image
                    src={image}
                    alt={`Vue ${index + 2} de ${commune?.name}`}
                    className="w-full h-full object-cover"
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CommuneOverview;